<ng-container *ngIf="status$ | async as status">
    <div class="flex justify-end items-start mb-1">
        <div *ngIf="status.total" class="text-xs pt-1 pr-2">
            {{status.count}} / {{status.total}} {{type}}
        </div>
    </div>
</ng-container>